export default __webpack_public_path__ + "static/media/no-annual-fee-purple.4bfa7b82.svg";